import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { HttpClientProvider } from '@services/http/client/http-client-provider';
import SettoriIndustriaDesktop from '@components/settori-industria/layout-desktop/layout-desktop';
import { GetAllIndustrySectorsRemoteCall } from '@services/http/remote-calls/snf-api/industry-sectors/get-all-industry-sectors.http-remote-call';
import { useSiteData } from '../../context/site-data-context';

export default function SettoriIndustria() {
  const intl = useIntl();
  const { serviceCategories, technologyCategories } = useSiteData();
  const [payload, setPayload] = useState({
    pages: [],
    mainSectionDescriptions: {},
    mainSectionImageUrl: '',
    mainSectionDarkTheme: false,
    navbarItems: []
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const httpClient = HttpClientProvider.getInstance();
      const industrySectorsRemoteCall = new GetAllIndustrySectorsRemoteCall(intl.locale);
      const data = await httpClient.execute(industrySectorsRemoteCall);
      if (!cancelled) setPayload(data);
    })();
    return () => {
      cancelled = true;
    };
  }, [intl.locale]);

  return (
    <SettoriIndustriaDesktop
      pages={payload.pages}
      mainSectionDescriptions={payload.mainSectionDescriptions}
      mainSectionImageUrl={payload.mainSectionImageUrl}
      mainSectionDarkTheme={payload.mainSectionDarkTheme}
      navbarItems={payload.navbarItems}
      serviceCategories={serviceCategories}
      technologyCategories={technologyCategories}
    />
  );
}
